<template>
    <charges-get
        :page="1"
        :per-page="2"
        :fee="fee"
        :rent="rent"
        :tenancy="tenancy"
        :include="[
            'payer',
            'payee',
            'rents(paginate:1,2)',
            'fees(paginate:1,2)',
            'properties',
        ]"
    >
        <div
            slot-scope="{
                data: charges,
                meta,
                error,
                is_loading,
                has_loaded,
                get
            }"
            class="flex flex-col h-full bg-white rounded shadow"
        >
            <header class="flex items-center flex-none h-16 px-4 border-b sm:px-6">
                <h3 class="text-base font-normal">Recent Payments</h3>
            </header>

            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="get"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <div
                v-else-if="meta.total == 0"
                class="flex-grow p-3 italic text-center rounded-b text-grey bg-grey-bg"
            >
                There's nothing here!
            </div>

            <template v-else>
                <landlords-current>
                    <table-ish
                        slot-scope="{ data: landlord }"
                        v-if="landlord"
                    >
                        <table-ish-row
                            v-for="charge in charges"
                            :key="charge.uuid"
                        >
                            <table-ish-cell>
                                <truncate-hack>
                                    {{ charge.payer.name }}
                                </truncate-hack>

                                <template slot="secondary">
                                    {{ charge.created_at | moment('D MMM YYYY') }}
                                </template>
                            </table-ish-cell>
                            <table-ish-cell
                                :shrink="true"
                                class="text-right"
                            >
                                {{ charge.amount | money }}

                                <template slot="secondary">
                                    <span
                                        v-if="charge.is_offline"
                                        class="px-2 text-xs font-semibold leading-none rounded-full bg-grey-lighter text-grey-darker"
                                    >
                                        Offline
                                    </span>

                                    <span
                                        v-else
                                        class="px-2 text-xs font-semibold leading-none rounded-full bg-blue-lighter text-blue-darker"
                                    >
                                        Money In
                                    </span>
                                </template>
                            </table-ish-cell>
                        </table-ish-row>
                    </table-ish>
                </landlords-current>

                <tenants-current>
                    <charges-list
                        slot-scope="{ data: tenant }"
                        v-if="tenant"
                        :charges="charges"
                    />
                </tenants-current>
            </template>
        </div>
    </charges-get>
</template>

<script>
    import ChargesGet from './charges-get'
    import ChargesList from './charges-list'
    import LandlordsCurrent from './landlords-current'
    import TenantsCurrent from './tenants-current'

    export default {
        components: {
            ChargesGet,
            ChargesList,
            LandlordsCurrent,
            TenantsCurrent
        },
        props: {
            fee: {
                type: String,
                default: null
            },
            rent: {
                type: String,
                default: null
            },
            tenancy: {
                type: String,
                default: null
            }
        }
    }
</script>
